import { Box } from "@mui/material";
import { AXIS_COLUMN_WIDTH, DATE_COLUMN_WIDTH } from "./TimelineRow";

const AXIS_LINE_WIDTH = 1;

export const GoalsTimelineAxis = () => (
  <Box
    position="absolute"
    top={0}
    bottom={0}
    left={DATE_COLUMN_WIDTH + (AXIS_COLUMN_WIDTH - AXIS_LINE_WIDTH) / 2}
    width={`${AXIS_LINE_WIDTH}px`}
    bgcolor="divider"
  />
);
